import { GbpPhotosView, GrowthDashboardTopBarActions } from '@elva/ui';
import { useNavigate } from 'react-router-dom';
import { AsyncBoundary } from '@/components/feedback';
import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { viewProps } from '@/data/viewProps';
import { useGbpPhotoMutations, useGbpPhotos } from '@/features/gbp-photos/hooks/useGbpPhotos';

export function GbpPhotosPage() {
  const navigate = useNavigate();

  usePageTopBar({
    actions: <GrowthDashboardTopBarActions />,
  });

  const { data, isPending, isError, error, refetch, isRefetching, isFetching } = useGbpPhotos();
  const { removePhoto } = useGbpPhotoMutations();

  return (
    <AsyncBoundary
      loading={isPending}
      error={data === undefined && isError ? error : undefined}
      onRetry={refetch}
      retrying={isRefetching}
    >
      <GbpPhotosView
        {...viewProps({
          categories: data?.categories,
          prompts: data?.prompts,
          kpis: data?.kpis,
          loading: isFetching || removePhoto.isPending,
          onBulkUpload: () => navigate('/gbp/photos/bulk-upload'),
          onUploadPhoto: (promptId: string) =>
            navigate('/gbp/photos/bulk-upload', {
              state: { promptId, openFilePicker: true },
            }),
          onRemovePhoto: (promptId: string) => {
            const photoId = data?.photoIdByPromptId[promptId];
            if (photoId) removePhoto.mutate(photoId);
          },
        })}
      />
    </AsyncBoundary>
  );
}
